import { render, staticRenderFns } from "./ChatCollect.vue?vue&type=template&id=26204f10&scoped=true"
import script from "./ChatCollect.vue?vue&type=script&lang=js"
export * from "./ChatCollect.vue?vue&type=script&lang=js"
import style0 from "./ChatCollect.vue?vue&type=style&index=0&id=26204f10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26204f10",
  null
  
)

export default component.exports